import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Observable, of } from "rxjs";
import { catchError, map, startWith, tap } from "rxjs/operators";
import { Cost } from "../models/cost.model";
import { NonLoaderHttpHeader } from "../models/non-loader.model";

@Injectable({
  providedIn: "root",
})
export class SearchService {
  private url = environment.url;

  constructor(private httpClient: HttpClient) {}

  fetchResults(queryString: string): Observable<Cost[]> {
    const httpHeaders = new HttpHeaders({
      "Non-Loader-Request": "no-loader",
    } as NonLoaderHttpHeader);
    const httpParams = { query: queryString };

    return this.httpClient.get<Cost[]>(this.url + "search", {
      headers: httpHeaders,
      params: httpParams,
    });
  }

  searchV2(queryString: string, employeeId?: number | null): Observable<{ ok: boolean; query: string; tookMs: number; total: number; empty: boolean; data: Cost[]; message: string }>{
    const httpHeaders = new HttpHeaders({
      "Non-Loader-Request": "no-loader",
    } as NonLoaderHttpHeader);
    const httpParams: any = { query: queryString };
    if (employeeId !== null && employeeId !== undefined) {
      httpParams.employeeId = employeeId.toString();
    }

    return this.httpClient.get<{
      ok: boolean;
      query: string;
      tookMs: number;
      total: number;
      empty: boolean;
      data: Cost[];
      message: string;
    }>(this.url + "search/v2", {
      headers: httpHeaders,
      params: httpParams,
    }).pipe(
      map((response) => {
        return response;
      })
    );
  }

  searchState(queryString: string, employeeId?: number | null): Observable<{ loading: boolean; data: Cost[]; empty: boolean; error: string | null }>{
    const phrase = (queryString || "").trim();
    if (phrase.length < 3) {
      return of({ loading: false, data: [], empty: false, error: null });
    }
    return this.searchV2(phrase, employeeId).pipe(
      map((res) => ({ loading: false, data: res.data, empty: res.empty, error: res.ok ? null : res.message })),
      startWith({ loading: true, data: [], empty: false, error: null }),
      catchError((err) => of({ loading: false, data: [], empty: true, error: (err && err.message) || "Search failed" }))
    );
  }
}
